// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.19 10C13.34 12.61 10.89 14.5 8 14.5C5.3 14.5 2.98 12.85 2 10.5',
  'M5.5 10.5L1.5 10.5L1.5 14.5',
  'M1.81 6C2.66 3.39 5.11 1.5 8 1.5C10.66 1.5 12.95 3.1 13.96 5.4',
  'M10.5 5.5L14.5 5.5L14.5 1.5',
];
